/**
 * InfinitSales - Calendar Service
 *
 * Tela de Calendário: eventos nativos (fonte de verdade na InfinitSales),
 * tipos de evento (nome + ícone) e conexão Google Calendar do workspace
 * (OAuth Composio). Endpoints: /api/calendar/*.
 */
import api from './api';

const calendarService = {
  // ---- Eventos ----
  async listEvents({ start, end, contactPhone } = {}) {
    const params = new URLSearchParams();
    if (start) params.set('start', start);
    if (end) params.set('end', end);
    if (contactPhone) params.set('contact_phone', contactPhone);
    const qs = params.toString();
    const res = await api.get(`/api/calendar/events${qs ? `?${qs}` : ''}`);
    return res.data?.data || [];
  },

  async createEvent(payload) {
    const res = await api.post('/api/calendar/events', payload);
    return res.data?.data;
  },

  async updateEvent(eventId, payload) {
    const res = await api.patch(`/api/calendar/events/${eventId}`, payload);
    return res.data?.data;
  },

  async deleteEvent(eventId) {
    const res = await api.delete(`/api/calendar/events/${eventId}`);
    return res.data?.data;
  },

  // ---- Tipos de evento (nome + ícone) ----
  async listEventTypes() {
    const res = await api.get('/api/calendar/event-types');
    return res.data?.data || [];
  },

  // Lista + meta ({read_only, reason}): com os tipos company-wide o membro
  // ve a lista do dono e a tela desabilita a edicao com o motivo.
  async getEventTypesWithMeta() {
    const res = await api.get('/api/calendar/event-types');
    return { types: res.data?.data || [], meta: res.data?.meta || {} };
  },

  async createEventType({ name, icon }) {
    const res = await api.post('/api/calendar/event-types', { name, icon });
    return res.data?.data;
  },

  async updateEventType(typeId, { name, icon }) {
    const res = await api.patch(`/api/calendar/event-types/${typeId}`, { name, icon });
    return res.data?.data;
  },

  async deleteEventType(typeId) {
    const res = await api.delete(`/api/calendar/event-types/${typeId}`);
    return res.data?.data;
  },

  // ---- Google Calendar (workspace) ----
  async googleStatus() {
    const res = await api.get('/api/calendar/google/status');
    return res.data?.data;
  },

  async googleConnect() {
    const res = await api.post('/api/calendar/google/connect');
    return res.data?.data;
  },

  // ---- Busca de contatos (p/ atrelar ao evento) ----
  async searchContacts(q) {
    const res = await api.get(`/api/calendar/contacts/search?q=${encodeURIComponent(q || '')}`);
    return res.data?.data || [];
  },

  // ---- Expediente: janela de atendimento, intervalos e FERIADOS ----
  // É o que o agente consulta antes de oferecer horário. Sem feriado
  // cadastrado, a agenda trata feriado como dia útil.
  async getSchedulingConfig() {
    const res = await api.get('/api/scheduling-config');
    return { config: res.data?.data || {}, suggested: res.data?.suggested_holidays || [] };
  },

  async saveSchedulingConfig(cfg) {
    const res = await api.put('/api/scheduling-config', cfg);
    return res.data?.data || {};
  },

  // Agendas da conexão Google (flag gcal_all_calendars): a tela de expediente
  // marca quais contam como ocupado para o agente. 404 = flag desligada.
  async getGoogleCalendars() {
    try {
      const res = await api.get('/api/scheduling-config/google-calendars');
      return { calendars: res.data?.data || [], connected: !!res.data?.connected };
    } catch (e) {
      if (e?.response?.status === 404) return { calendars: [], connected: false };
      throw e;
    }
  },
};

export default calendarService;
